document.addEventListener('DOMContentLoaded', function() {
  const heroSection = document.querySelector('.custom-hero-section');
  if (!heroSection) return;
  
  // Check if on mobile device
  const isMobile = window.innerWidth <= 768;
  
  // Don't run animations on mobile
  if (isMobile) return;
  
  const heading = heroSection.querySelector('.hero-heading.transitions-enabled');
  const mainImage = heroSection.querySelector('.hero-main-img.transitions-enabled');
  const scatteredItems = heroSection.querySelectorAll('.scattered-item.transitions-enabled');
  
  let animationsTriggered = false;
  
  function triggerAnimations() {
    if (animationsTriggered) return;
    animationsTriggered = true;
    
    if (heading) heading.classList.add('fade-in');
    if (mainImage) mainImage.classList.add('zoom-in');
    
    scatteredItems.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add('slide-up');
      }, index * 120);
    });
    
    const totalInitialDelay = (scatteredItems.length - 1) * 120 + 800 + 1000;
    setTimeout(() => {
      scatteredItems.forEach((item) => {
        item.classList.add('floating');
      });
    }, totalInitialDelay);
  }
  
  setTimeout(() => {
    triggerAnimations();
  }, 200);
});
